import axios from "axios";
import router from "../router";
import parameters from "./parameters";
//不同环境下的地址
// https://app.yantaiche.cn
// let baseURL = window.location.protocol + "//" + window.location.hostname;
// let baseURL = "https://app.yantaiche.cn";
// let baseURL = "https://apptest.yantaiche.cn";
let baseURL = parameters.baseURL
    // //node中的环境变量process.env,也就是我们新增开发、生产的配置文件
    // if (process.env.NODE_ENV === "development") {
    //     // baseURL = "/" //这里可在vue.config.js做一个代理【代理代码见下】
    //     baseURL = "https://app.yantaiche.cn";
    //     // baseURL = "https://apptest.yantaiche.cn";
    // } else {
    //     // baseURL = "/";
    //     baseURL = "https://app.yantaiche.cn";
    //     // baseURL = "https://apptest.yantaiche.cn";
    // }

//创建axios实例
const request = axios.create({
    timeout: 5000,
    baseURL: baseURL,
});

// 获取本地存储的token
const getToken = () => {
    let data = JSON.parse(localStorage.getItem("userinfo"));
    if (data) {
        return data.token;
    }
    return {};
};

//所有请求设置了授权头信息【请求头中设置cookie信息，一直携带，判权】
// axios.defaults.headers.common['Authorization'] = `${cookie}`;
//这里是设置发送json格式参数
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "*/*";
// axios.defaults.headers.get["Connection"] = "keep-alive";

//请求拦截器
request.interceptors.request.use(
    //发送之前想要做些什么
    (config) => {
        let token = getToken();
        // token是否过期，是否重新登陆等等
        // 此处可修改一些基本数据
        // config[baseURL,[data,[headers,[method,[timeout,[url]   等
        //        基础地址,请求参数,头部, 请求方式, 超时,  请求地址  等
        // console.log('请求参数',config);
        // if(config.url == '/api/User/login'){
        //   if(token){
        //     config.headers.Cookie = token
        //   } else {
        //     this.$router.push('/login');
        //   }
        // } else {
        //   if(token){
        //     config.headers.Cookie = token
        //   } else {
        //     this.$router.push('/login');
        //   }
        // }
        if (token) {
            config.headers.token = token;
        }
        // config.headers.Cookie = getToken;
        return config;
    },
    //方法返回一个带有拒绝原因的 Promise 对象。
    (error) => Promise.reject(error)
);
/**************移除拦截器****************/
// 动态移除
// const me = axios.interceptors.request.use(function () {/*...*/});
// axios.interceptors.request.eject(me);
/***************************************/

//响应拦截器（对请求结束后进行一些操作，，例如:统一收集报错）
request.interceptors.response.use(
    //请求成功
    (res) => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
    //请求失败
    (error) => {
        //可根据不同的状态去区分不同的错误，达到不同效果
        if (error.response.status) {
            error.response.status === 404 ?
                alert("请求不存在！！") :
                alert("请求报错请联系管理员！");
            // 请求失败重新登录
            if (error.response.data.msg == "请登录后操作") {
                localStorage.removeItem("userinfo");
                router.replace("/login");
            }
        }
        return Promise.reject(error);
    }
);

export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js